import { useDispatch } from 'react-redux';
import { actionSetCompleteCheckoutType } from 'src/action';


export function useSetCompleteCheckoutType(setCompleteCheckoutType: "pre_process_order" | "process_order"): void {
    const dispatch = useDispatch();
    dispatch(actionSetCompleteCheckoutType(setCompleteCheckoutType));
}
